<template>
  <v-container
    fluid
    style="margin-bottom: 70px"
    ref="top"
  >
    <v-row
      class="mt-2"
      justify="center"
    >
      <v-col
        cols="12"
        md="11"
        class="py-0"
      >
        <v-row>
          <v-col class="d-flex flex-column align-start">
            <h1 class="primary--text">
              {{
                `${
                  isEdit ? 'Editar' : isCopy ? 'Cópiar' : ''
                } Configurações de Transformações do Layout`
              }}
            </h1>
          </v-col>
          <v-col
            cols="12"
            md="5"
            class="py-0"
          >
            <v-stepper
              value="2"
              style="
                background-color: var(--v-muted-base);
                box-shadow: none !important;
              "
              class="stepper"
            >
              <v-stepper-header>
                <v-stepper-step
                  complete
                  step="1"
                >
                  Layout
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2">
                  Transformações
                  <br />
                  e Mapa de Campo
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      justify="center"
      class="mt-5"
    >
      <v-col
        cols="12"
        md="11"
        class="pa-0"
      >
        <v-form
          ref="formValidation"
          v-if="Object.keys(layoutData).length > 0"
        >
          <HeaderConfigurations
            @isEditControl="isEditControl"
            @isCopyControl="isCopyControl"
          />
        </v-form>
      </v-col>
    </v-row>

    <v-form ref="formTransformations">
      <v-row justify="center">
        <v-col
          cols="12"
          md="11"
          class="pa-0"
        >
          <TransformationTable
            :propsLayout="layout"
            :propsFromToFields="fromToFields"
            :dataSourceColumns="dataSourceColumns"
            :isEdit="isEdit"
            :isCopy="isCopy"
            :isImport="true"
            @scrollComponent="scrollComponent"
            @overlayControll="overlayControll"
          />
        </v-col>
      </v-row>
    </v-form>

    <v-form
      ref="formCalculatedField"
      v-if="this.layout.typeIntegrationValue === 'SHIPPING'"
    >
      <v-row justify="center">
        <v-col
          cols="12"
          md="11"
          class="px-0"
        >
          <CalculatedFieldTable
            :propsLayout="layout"
            :isEdit="isEdit"
            :isCopy="isCopy"
            @scrollComponent="scrollComponent"
            @overlayControll="overlayControll"
          />
        </v-col>
      </v-row>
    </v-form>

    <v-snackbar
      v-model="snackbar.show"
      timeout="10000"
      top
      elevation="24"
      :color="snackbar.type"
    >
      <div class="text-center foreground-accent--text">{{ snackbar.text }}</div>
      <template v-slot:action="{ attrs }">
        <v-icon
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          close
        </v-icon>
      </template>
    </v-snackbar>

    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="120"
        center
      >
        <v-row class="justify-center">
          <v-col align="center">Processando...</v-col>
        </v-row>
      </v-progress-circular>
    </v-overlay>

    <DynamicDialogInformation
      ref="DynamicDialogInformation"
      :widthModalValue="widthModal"
      :heightCardValue="heightCard"
    >
      <div slot="textInfo">
        <v-row
          v-if="
            transformationsOrderEmpty && transformationsOrderEmpty.length > 0
          "
        >
          <v-col cols="12">
            Por favor preencha as ordens das transformações abaixo:
            <div
              v-for="(transformationEmpty, index) in transformationsOrderEmpty"
              :key="index"
            >
              <h5
                class="error--text"
                style="word-break: break-word"
              >
                {{
                  `Coluna: [${transformationEmpty.column}] - Transformação: [${transformationEmpty.transformation}]`
                }}
              </h5>
            </div>
          </v-col>
        </v-row>
        <v-row
          justify="center"
          v-if="parametersValueEmpty && parametersValueEmpty.length > 0"
          :class="
            transformationsOrderEmpty && transformationsOrderEmpty.length > 0
              ? 'mt-8'
              : ''
          "
        >
          <v-col cols="12">
            Por favor preencha os valores dos parâmetros abaixo:
            <div
              v-for="(
                transformationParameterValueEmpty, index
              ) in parametersValueEmpty"
              :key="index"
            >
              <h5
                class="error--text"
                style="word-break: break-word"
              >
                {{
                  `Coluna: [${transformationParameterValueEmpty.column}] - Transformação: [${transformationParameterValueEmpty.transformation}] - Parâmetro: [${transformationParameterValueEmpty.parameter}]`
                }}
              </h5>
            </div>
          </v-col>
        </v-row>
      </div>
    </DynamicDialogInformation>

    <Footer
      style="z-index: 2"
      @voltar="onClickBack"
      @cancelar="onClickCancel"
      @salvar="onClickSave"
      saveButtonLabel="Concluir"
    />
  </v-container>
</template>

<script>
import Rules from '@/shared/validators/formRules';
import Footer from '@/components/Footer/Footer.vue';
import TransformationTable from '@/components/Layout/Transformations/Table/transformationTable.vue';
import CalculatedFieldTable from '@/components/Layout/Transformations/Table/calculatedFieldTable.vue';
import DataSourceService from '@/services-http/sdi/DataSourceService';
import DynamicDialogInformation from '@/components/DynamicDialogInformation/DynamicDialogInformation.vue';
import LayoutService from '@/services-http/sdi/LayoutService';
import HeaderConfigurations from '@/components/Layout/ImportSettingsHeaders/headerConfigurations.vue';
import lodash from 'lodash';
import { mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    Footer,
    DynamicDialogInformation,
    TransformationTable,
    CalculatedFieldTable,
    HeaderConfigurations,
  },

  data: () => ({
    fromToFields: [],
    transformationsOrderEmpty: [],
    parametersValueEmpty: [],
    dataSourceColumns: [],

    isEdit: false,
    isCopy: false,
    overlay: true,
    widthModal: 800,
    heightCard: 800,

    layoutType: {},
    layout: {},
    snackbar: {
      show: false,
      type: '',
      text: '',
    },
  }),

  beforeMount() {
    window.addEventListener('beforeunload', this.handlePageRefresh);
    this.setSessionStoreData();
  },

  async mounted() {
    this.scrollTo();
    this.loadSessionStorage();
    await this.loadField();
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handlePageRefresh);
  },

  methods: {
    ...mapMutations({
      setLayoutEntityType: 'layout-import/setLayoutEntityType',
      setLayoutType: 'layout-import/setLayoutType',
      setLayout: 'layout-import/setLayout',
      resetModule: 'layout-import/resetModule',
    }),
    handlePageRefresh() {
      sessionStorage.setItem('layout', JSON.stringify(this.layout));
      sessionStorage.setItem('layoutType', JSON.stringify(this.layoutType));
      sessionStorage.setItem('layoutEntityType', this.layoutEntityType);
    },
    setSessionStoreData() {
      if (sessionStorage.getItem('layout')) {
        this.setLayout(JSON.parse(sessionStorage.getItem('layout')));
        this.layout = JSON.parse(sessionStorage.getItem('layout'));
        sessionStorage.removeItem('layout');
      }
      if (sessionStorage.getItem('layoutType')) {
        this.setLayoutType(JSON.parse(sessionStorage.getItem('layoutType')));
        this.layoutType = JSON.parse(sessionStorage.getItem('layoutType'));
        sessionStorage.removeItem('layoutType');
      }
      if (sessionStorage.getItem('layoutEntityType')) {
        this.setLayoutEntityType(sessionStorage.getItem('layoutEntityType'));
        sessionStorage.removeItem('layoutEntityType');
      }
    },
    loadSessionStorage() {
      this.layoutType = JSON.parse(JSON.stringify(this.layoutTypeData));
      this.layout = JSON.parse(JSON.stringify(this.layoutData));

      this.layout.columns.sort((a, b) => (a.order > b.order ? 1 : -1));

      this.setIdDataSource();
    },
    setIdDataSource() {
      this.layout.columns.forEach((column) => {
        if (!column.idDataSource) {
          column.idDataSource = 2;
        }
      });
    },
    async loadField() {
      this.dataSourceColumns = [];

      await this.dataSourceService.FindAll().then((response) => {
        let movementFilter = [];
        if (response && response.data) {
          movementFilter = response.data.sort((a, b) =>
            a.label > b.label ? 1 : -1
          );
          this.dataSourceColumns = movementFilter;
          this.fromToFields = movementFilter.find((item) =>
            this.layout.typeIntegrationValue === 'PAYROLL'
              ? item.value === 'recebimento_folha'
              : item.value === 'registro_movimentacao'
          ).columns;
        }
      });
    },
    onClickBack() {
      sessionStorage.setItem('layout', JSON.stringify(this.layout));
      sessionStorage.setItem('layoutType', JSON.stringify(this.layoutType));
      this.setLayout(this.layout);
      this.redirectRouter('back');
    },
    onClickCancel() {
      this.setLayoutEntityType('');
      this.redirectRouter('cancel');
    },
    async onClickSave() {
      if (this.$refs.formValidation.validate()) {
        if (
          this.$refs.formTransformations.validate() &&
          (this.$refs.formCalculatedField
            ? this.$refs.formCalculatedField.validate()
            : true)
        ) {
          this.overlay = true;
          await this.captureIsCheckedItems();
        } else {
          this.overlay = false;
          this.customizeSnackbarMessage(
            'error',
            'Verifique os dados das colunas do layout'
          );
        }
      } else {
        this.overlay = false;
        this.customizeSnackbarMessage(
          'error',
          'Verifique os campos obrigatórios de configurações do layout'
        );
      }
    },
    redirectRouter(type) {
      if (type === 'save') {
        this.$router.push(
          this.$route.query.financialGroupId
            ? {
                name: 'LayoutImports',
                query: { financialGroupId: this.layout.financialGroupId },
              }
            : { name: 'LayoutImports' }
        );
      }
      if (type === 'back') {
        if (this.isEdit) {
          this.$router.push(
            this.$route.query.financialGroupId
              ? {
                  name: 'LayoutImportColumnEditConfigs',
                  query: { financialGroupId: this.layout.financialGroupId },
                }
              : { name: 'LayoutImportColumnEditConfigs' }
          );
        } else if (this.isCopy) {
          this.$router.push(
            this.$route.query.financialGroupId
              ? {
                  name: 'LayoutImportColumnCopyConfigs',
                  query: { financialGroupId: this.layout.financialGroupId },
                }
              : { name: 'LayoutImportColumnCopyConfigs' }
          );
        } else {
          this.$router.push(
            this.$route.query.financialGroupId
              ? {
                  name: 'LayoutImportColumnConfigs',
                  query: { financialGroupId: this.layout.financialGroupId },
                }
              : { name: 'LayoutImportColumnConfigs' }
          );
        }
      }
      if (type === 'cancel') {
        this.resetModule();
        this.$router.push('/home-all-menus');
      }
    },
    async captureIsCheckedItems() {
      this.listTransformationsAux = [];
      const layoutColumnsModify = lodash.cloneDeep(this.layout.columns);
      layoutColumnsModify.forEach((element, columnIndex) => {
        if (element.columnType === 'DEFAULT') {
          element.transformations.forEach((item, transformationIndex) => {
            if (item && item.isChecked === true) {
              this.listTransformationsAux.push({
                ...item,
                columnIndex,
                transformationIndex,
              });
            }
          });
        }
      });
      await this.addRealTransformationInColumns(layoutColumnsModify);
    },
    async addRealTransformationInColumns(layoutColumnsModify) {
      this.listTransformationsAux.forEach((element) => {
        const layoutColumnIndex = layoutColumnsModify.findIndex(
          (item, index) => element.columnIndex === index
        );
        const layoutColumnTransformationIndex = layoutColumnsModify[
          layoutColumnIndex
        ].transformations.findIndex(
          (item, index) => element.transformationIndex === index
        );
        layoutColumnsModify[layoutColumnIndex].transformations[
          layoutColumnTransformationIndex
        ] = element;
      });
      await this.separateIsCheckedInTransformations(layoutColumnsModify);
    },
    async separateIsCheckedInTransformations(layoutColumnsModify) {
      const allLayoutColumnsAux = lodash.cloneDeep(layoutColumnsModify);
      allLayoutColumnsAux.forEach((element) => {
        delete element.id;
        delete element.idLayout;

        if (element.columnType !== 'DEFAULT') return;

        element.transformations = element.transformations
          .filter((item) => item.isChecked)
          .map((t) => ({
            column: t.id,
            name: t.name,
            order: t.order ? Number(t.order) : '',
            parameters: t.parameters,
            template: t.template,
            field: t.field,
          }));
      });
      const allColumns = await lodash.cloneDeep(allLayoutColumnsAux);
      this.verifyParameters(allColumns);
    },
    verifyParameters(allLayoutColumnsAux) {
      this.transformationsOrderEmpty = [];
      this.parametersValueEmpty = [];
      if (!this.validateNoReferenceComplementaryColumns()) {
        this.customizeSnackbarMessage(
          'error',
          'Colunas complementares "SEM REFERÊNCIA" devem conter ao menos uma transformação configurada.'
        );
        this.overlay = false;
        return;
      }
      allLayoutColumnsAux.forEach((column) => {
        if (column.columnType === 'DEFAULT') {
          column.transformations.forEach((transformation) => {
            if (transformation.order === '') {
              this.transformationsOrderEmpty.push({
                transformation: transformation.name,
                column: column.name,
              });
            }
            if (
              transformation.name === 'Depara' &&
              transformation.parameters &&
              transformation.parameters.length < 4
            ) {
              this.parametersValueEmpty.push({
                transformation: transformation.name,
                parameter: 'Não há parâmetros suficientes',
                column: column.name,
              });
            }
            if (
              transformation.parameters &&
              transformation.parameters.length > 0
            ) {
              transformation.parameters.forEach((parameter) => {
                const existingValue = 'value' in parameter;
                if (
                  transformation.template !== 'concatenar_campos' &&
                  (!existingValue ||
                    (parameter.name !== 'SENAO' && parameter.value === ''))
                ) {
                  if (
                    parameter.name !== 'Campo' &&
                    (transformation.template !== 'replace_all' ||
                      transformation.template !== 'regex') &&
                    parameter.order !== 3
                  ) {
                    this.parametersValueEmpty.push({
                      transformation: transformation.name,
                      parameter: parameter.name,
                      column: column.name,
                    });
                  }
                }
                if (parameter.name === 'Campo') {
                  parameter.name = column.name;
                }
                if (
                  (transformation.template === 'replace_all' ||
                    transformation.template === 'regex') &&
                  parameter.order === 3
                ) {
                  parameter.value = parameter.value ? parameter.value : '';
                }
              });
            } else {
              transformation.parameters.push({
                isAlphanumeric: false,
                isField: true,
                order: 1,
                name: column.name,
                value: column.name,
              });
            }
          });
        }
      });

      if (
        this.transformationsOrderEmpty.length === 0 &&
        this.parametersValueEmpty.length === 0
      ) {
        this.allLayoutColumns = lodash.cloneDeep(allLayoutColumnsAux);
        this.payloadSubmited();
      } else {
        this.$refs.DynamicDialogInformation.open();
        this.overlay = false;
      }
    },
    async payloadSubmited() {
      const layout = lodash.cloneDeep(this.layout);
      layout.isModel = false;
      layout.columns = this.allLayoutColumns;
      await this.deleteIdsForNewLayout(layout);
      if (this.isEdit) {
        this.isEditLayoutImport(layout);
      } else {
        this.isSaveAndCopyLayoutImport(layout);
      }
    },
    async deleteIdsForNewLayout(layout) {
      delete layout.queryTransformation;

      if (layout.tags && layout.tags.length > 0) {
        layout.tags.forEach((element) => {
          delete element.id;
        });
      }

      if (layout.columns && layout.columns.length > 0) {
        layout.columns.forEach((element) => {
          delete element.id;
          delete element.idLayout;

          if (element.transformations && element.transformations.length > 0) {
            element.transformations.forEach((item) => {
              delete item.id;
              item.parameters.forEach((data) => {
                delete data.id;
              });
            });
          }
        });
      }
    },
    validateNoReferenceComplementaryColumns() {
      const noReferenceColumns = this.layout.columns.filter(
        (column) =>
          column.name === 'Sem Referência' &&
          column.complementaryLayout === true
      );
      let valid = true;
      noReferenceColumns.forEach((column) => {
        if (
          column.transformations.every(
            (transformation) => transformation.isChecked === false
          )
        ) {
          valid = false;
        }
      });
      return valid;
    },
    isSaveAndCopyLayoutImport(layout) {
      delete layout.id;

      if (this.isCopy) {
        layout.columns.forEach((el) => {
          delete el.id;
          delete el.idLayout;
        });
      }

      layout.entityType = this.layoutEntityType;

      this.removeRelationFields(layout);

      const payload = this.mountPayload(layout);

      this.layoutService
        .Save(payload)
        .then(() => {
          this.overlay = false;
          this.customizeSnackbarMessage(
            'success',
            'Layout cadastrado com sucesso!'
          );
          setTimeout(() => {
            this.redirectRouter('save');
          }, 250);
        })
        .catch(() => {
          this.overlay = false;
          this.customizeSnackbarMessage(
            'error',
            'Ocorreu um erro ao criar o modelo de layout, tente novamente!'
          );
        });
    },
    isEditLayoutImport(layout) {
      this.removeRelationFields(layout);

      layout.entityType = this.layoutEntityType;

      const payload = this.mountPayload(layout);

      this.layoutService
        .Update(layout.id, payload)
        .then(() => {
          this.overlay = false;
          this.customizeSnackbarMessage(
            'success',
            'Modelo editado com sucesso!'
          );
          setTimeout(() => {
            this.redirectRouter('save');
          }, 1000);
        })
        .catch(() => {
          this.overlay = false;
          this.customizeSnackbarMessage(
            'error',
            'Ocorreu um erro ao editar o modelo de layout, tente novamente!'
          );
        });
    },
    mountPayload(layout) {
      let { columns, ...layoutData } = { ...layout };

      const defaultColumns = columns.filter(
        (column) => column.columnType === 'DEFAULT'
      );
      const virtualColumns = this.mountVirtualColumnsPayload(columns);

      this.validateVirtualColumns(virtualColumns);

      layoutData.columns = defaultColumns;
      layoutData.virtualColumns = virtualColumns;

      return layoutData;
    },
    mountVirtualColumnsPayload(columns) {
      const virtualColumns = columns.filter(
        (column) => column.columnType === 'VIRTUAL'
      );

      const virtualColumnsPayload = virtualColumns.map((virtualColumn) => ({
        function: virtualColumn.function,
        name: virtualColumn.name,
        sequencial: virtualColumn.order,
      }));

      return virtualColumnsPayload;
    },
    validateVirtualColumns(virtualColumns) {
      if (virtualColumns.length === 0) return;

      const functions = new Set();

      const duplicateds = virtualColumns.filter((virtualColumn) => {
        if (functions.has(virtualColumn.function)) return true;

        functions.add(virtualColumn.function);

        return false;
      });

      if (duplicateds.length > 0) {
        this.overlay = false;

        throw this.customizeSnackbarMessage(
          'error',
          'Há funcões duplicadas entre suas colunas virtuais, corrija para prosseguir.'
        );
      }
    },
    // Remoção de campos de relacionamento com o layout importação.
    // Ref. atividade XIPP-9719, onde foi removido o relacionamento entre grupos, operadoras, contratos e subcontratos
    // no form do layout importação.
    removeRelationFields(layout) {
      delete layout.financialGroupId;
      delete layout.financialGroupName;
      delete layout.contractId;
      delete layout.contractName;
      delete layout.subContractId;
      delete layout.subContractName;
      delete layout.insuranceCarrierId;
      delete layout.insuranceCarrierName;
      delete layout.collectorIntegrationConfigId;
    },
    customizeSnackbarMessage(type, text) {
      this.snackbar.show = true;
      this.snackbar.type = type;
      this.snackbar.text = text;
    },
    overlayControll(data) {
      this.overlay = data;
    },
    scrollTo() {
      this.$refs.top.scrollIntoView({ behavior: 'smooth' });
    },
    isEditControl(data) {
      this.isEdit = data;
    },
    isCopyControl(data) {
      this.isCopy = data;
    },
    scrollComponent(data) {
      if (data) {
        this.scrollTo();
      }
    },
  },

  computed: {
    ...mapGetters({
      layoutEntityType: 'layout-import/layoutEntityType',
      layoutTypeData: 'layout-import/layoutType',
      layoutsData: 'layout-import/layouts',
      layoutData: 'layout-import/layout',
    }),
  },

  created() {
    this.rule = new Rules();
    this.dataSourceService = new DataSourceService();
    this.layoutService = new LayoutService();
  },
};
</script>
